import { render } from "./BaseSwitch.vue?vue&type=template&id=cea462e8&scoped=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"

import "./BaseSwitch.vue?vue&type=style&index=0&id=cea462e8&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea462e8"]])

export default __exports__